import React from 'react';
import { useHistory } from 'react-router-dom';
import { breakpoints, colors } from '../config';
import iconArrowLeft from '../../assets/arrow-left.svg';

const BackButton = props => {
  const history = useHistory();

  const handleClick = () => {
    history.goBack();
  };

  return (
    <button type="button" onClick={handleClick} {...props}>
      atrás
      <style jsx>{`
        button {
          background-color: transparent;
          border: 0;
          color: ${colors.brown};
          cursor: pointer;
          display: inline-block;
          font-family: inherit;
          font-size: 18px;
          font-weight: bold;
          padding: 24px 0;
          transition: transform 0.1s ease;
          width: 100%;
        }

        @media screen and (min-width: ${breakpoints.md}) {
          button {
            width: auto;
            background-image: url(${iconArrowLeft});
            background-repeat: no-repeat;
            background-position: -3px center;
            padding-left: 28px;
          }
        }

        button:disabled {
          opacity: 0.35;
        }

        button:active {
          transform: scale(0.975);
        }
      `}</style>
    </button>
  );
};

export default BackButton;
